import { useCallback } from 'react';

import { Translate, useInterpolatedTranslationKey, useTranslateDeclension } from '@dreryk/react-common';
import { ContentCopyIcon, Link, LinkVariant, RemoveIcon, StyledFlex } from '@dreryk/react-components';

import { prescriptionTranslationKeys } from '../../../../../../../translations';

import { StyledStageHeaderTitle } from './StageHeader.styled';

type StageHeaderProps = {
   readonly index: number;
   readonly isBreak: boolean;
   readonly ordinalNumber: number;
   readonly days: number;
   readonly duplicable: boolean;
   readonly onDuplicate: (index: number) => void;
   readonly onRemove: (index: number) => void;
};

export const StageHeader = (props: StageHeaderProps): JSX.Element => {
   const daysSuffix = useTranslateDeclension(
      props.days,
      prescriptionTranslationKeys.day,
      prescriptionTranslationKeys.days,
      prescriptionTranslationKeys.days
   );

   const title = useInterpolatedTranslationKey(
      props.isBreak
         ? prescriptionTranslationKeys.extendedDosage.breakHeader
         : prescriptionTranslationKeys.extendedDosage.cycleHeader,
      { number: String(props.ordinalNumber), days: `${props.days} ${daysSuffix}` }
   );

   const handleDuplicate = useCallback(
      () => props.onDuplicate(props.index),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [props.onDuplicate, props.index]
   );
   const handleRemove = useCallback(
      () => props.onRemove(props.index),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [props.onRemove, props.index]
   );

   return (
      <StyledFlex direction={'row'} alignItems={'center'} justifyContent={'space-between'} gap={'8px'}>
         <StyledStageHeaderTitle testId={`stageHeader-${props.index}`}>
            <Translate>{title}</Translate>
         </StyledStageHeaderTitle>
         <StyledFlex direction={'row'} alignItems={'center'} gap={'12px'}>
            <Link
               testId={`duplicateStage-${props.index}`}
               icon={<ContentCopyIcon />}
               label={prescriptionTranslationKeys.extendedDosage.duplicate}
               onClick={handleDuplicate}
               disabled={!props.duplicable}
               block={false}
            />
            <Link
               testId={`removeStage-${props.index}`}
               icon={<RemoveIcon />}
               variant={LinkVariant.ERROR}
               label={prescriptionTranslationKeys.extendedDosage.remove}
               onClick={handleRemove}
               block={false}
            />
         </StyledFlex>
      </StyledFlex>
   );
};
